import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "attach",
  "use": "attach-usage",
  "viewBox": "0 0 12 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 22\" id=\"attach\"><path fill=\"none\" stroke=\"#7E8FA5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M3.5 15.583v-6.25c0-1.38.702-2.5 2.083-2.5 1.38 0 2.084 1.12 2.084 2.5v7.917c0 2.07-1.263 3.75-3.334 3.75C2.263 21 1 19.32 1 17.25V6.833c0-2.76 1.822-5 4.583-5s4.584 2.24 4.584 5v7.5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol